const defaultAdsLabelStyles = {
  position: 'relative !important',
  padding: '.8px 4px !important',
  margin: '0 5px 0 0 !important',
  background: 'transparent !important',
  color: '#78718a !important',
  lineHeight: '1.364 !important',
  fontSize: '10px !important',
  fontWeight: '400 !important',
  fontFamily: 'Segoe UI,Segoe WP,Arial,Sans-Serif',
  border: '.5px solid #78718a !important',
  borderRadius: '4px !important',
};

export const getMmaInMsanV2PlacementBaseStyles = () => ({
  placementCard: {
    border: '1px solid #c8c8c8',
    boxShadow: 'unset !important',
    borderRadius: '0px !important',
  },
  placementImageContainer: undefined,
  placementTextContainer: undefined,
  placementAdsLabel: undefined,
  placementGradient: undefined,
  placementShortHeadline: undefined,
  placementLongHeadline: undefined,
  placementFinalUrl: undefined,
  placementDescription: undefined,
  placementCallToAction: undefined,
  placementBusinessNameWithAdsLabel: undefined,
});

export const getMmaInMsanV2MicrosoftEdgeCarousel201x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      '&:hover $placementGradient': {
        height: '480px !important',
        top: -145,
      },
      '&:hover $placementShortHeadline': {
        color: 'white',
        textDecoration: 'underline',
      },
      width: '612px !important',
      height: 304,
    },

    placementGradient: {
      display: 'block',
      width: '100%',
      height: '280px !important',
      top: 55,
      backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
      overflow: 'hidden',
    },

    placementTextContainer: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      padding: 16,
      fontSize: 10,
      color: '#bebebe',
    },

    placementShortHeadline: {
      color: 'white',
      width: 592,
      height: 'auto',
      fontSize: 28,
      maxHeight: 108,
      fontWeight: '600',
      lineHeight: '36px',
      marginBottom: 0,
      paddingBottom: 5,
    },

    placementBusinessNameWithAdsLabel: {
      padding: '4px 0 !important',
      margin: '9px 5px 5px 0px !important',
      fontSize: '12px !important',
      lineHeight: '16px !important',
      background: 'transparent !important',
      color: 'rgba(255, 255, 255, 0.7) !important',
      borderRadius: '2px !important',

      '& .ads-label': {
        ...defaultAdsLabelStyles,
        margin: '0 !important',
        color: 'rgba(255, 255, 255, 0.7) !important',
        background: 'transparent !important',
        border: '2px solid rgba(255, 255, 255, 0.3) !important',
        opacity: '1 !important',
        fontSize: '12px !important',
        lineHeight: '16px !important',
      },
      '& .business-name': {
        color: 'hsla(0,0%,100%,.7) !important',
        padding: '0 0 0 4px !important',
      },
    },
  };
};

export const getMmaInMsanV2MSANBanner2x1Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '360px !important',
      height: 88,
      padding: '0px !important',
      background: '#fff',
      flexDirection: 'row !important',
    },

    placementImageContainer: {
      float: 'left',
      width: 180,
      height: 90,
      marginRight: 10,
    },

    placementTextContainer: {
      color: '#333',
      fontSize: 10,
      lineHeight: '16px',
    },

    placementShortHeadline: {
      color: 'rgba(0, 0, 0, 0.83)',
      height: 45,
      margin: '8px 8px 8px 0',
      overflow: 'hidden',
      fontSize: 15,
      fontWeight: 600,
      lineHeight: '22px',
      paddingBottom: 5,
    },

    placementBusinessNameWithAdsLabel: {
      padding: '2px 0 !important',
      borderRadius: '2px !important',

      '& .ads-label': {
        ...defaultAdsLabelStyles,
        color: 'rgba(46,46,46,.7) !important',
        fontSize: '11px !important',
      },
      '& .business-name': {
        padding: '0 !important',
      },
    },
  };
};

export const getMmaInMsanV2MSANRiver191x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '300px !important',
      height: 304,
      padding: '0px !important',
    },

    placementTextContainer: {
      width: 300,
      height: 147,
      padding: 12,
      background: 'linear-gradient(112.05deg, #FFFFFF 35.59%, #E1E1E1 100%)',
      fontSize: 10,
      lineHeight: '16px',
    },

    placementShortHeadline: {
      position: 'relative',
      top: 0,
      color: '#1A1A1A',
      width: 268,
      fontFamily: 'Segoe UI Variable Static Text',
      fontStyle: 'normal',
      fontSize: 20,
      lineHeight: 1.1,
      fontWeight: 600,
      paddingBottom: 5,
    },

    placementDescription: {
      color: '#4D4C4C',
      width: 268,
      fontSize: 14,
      fontFamily: 'Segoe UI Variable Static Text',
      fontStyle: 'normal',
      margin: '4px 0 0 0',
      lineHeight: 1.43,
      fontWeight: 400,
    },

    placementBusinessNameWithAdsLabel: {
      width: 270,
      padding: '4px 0 !important',
      margin: '9px 5px 0px 0px !important',
      fontSize: '11px !important',
      lineHeight: '15px !important',
      borderRadius: '2px !important',
      position: 'absolute',
      bottom: 11,
      background: 'transparent !important',

      '& .ads-label': {
        ...defaultAdsLabelStyles,
        margin: '0 !important',
        color: 'rgba(43,43,43,.8) !important',
        opacity: '1 !important',
        fontSize: '11px !important',
        lineHeight: '15px !important',
        fontFamily: 'Segoe UI Variable Static Small !important',
      },
      '& .business-name': {
        padding: '0 0 0 4px !important',
        fontFamily: 'Segoe UI Variable Static Small !important',
      },
      '& .ads-icon': {
        float: 'right',
        widht: 16,
        height: 16,
      },
    },
  };
};

export const getMmaInMsanV2MSNCarousel169x100Styles = (theme) => {
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      '&:hover $placementGradient': {
        height: '480px !important',
        top: -80,
      },
      width: '628px !important',
      height: 372,
    },

    placementGradient: {
      display: 'block',
      width: '100%',
      height: '280px !important',
      top: 120,
      backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
    },

    placementTextContainer: {
      position: 'absolute',
      left: 20,
      bottom: 25,
      fontSize: 10,
      lineHeight: '16px',
      color: '#bebebe',
    },

    placementLongHeadline: {
      width: 576,
      fontSize: 28,
      // maxHeight: 108,
      height: 108,
      fontWeight: 600,
      marginBottom: 0,
      color: 'white',
      lineHeight: '36px',

      '& .multi-line-processed-text': {
        position: 'absolute',
        bottom: 30,
      },
    },

    placementBusinessNameWithAdsLabel: {
      '& .ads-label': {
        ...defaultAdsLabelStyles,
        color: '#bebebe !important',
        opacity: '1 !important',
        border: 'unset !important',
      },
      '& .business-name': {
        padding: '0 !important',
        color: '#bebebe !important',
      },
      '& .ads-icon': {
        float: 'right',
        widht: 12,
        height: 12,
      },
    },
  };
};

export const getMmaInMsanV2MSNPartnerStripe153x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);
  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '302px !important',
      height: 296,
    },

    placementTextContainer: {
      padding: 10,
      width: 282,
      height: 98,
      color: '#333',
      fontSize: 10,
      lineHeight: '16px',
    },

    placementLongHeadline: {
      top: -6,
      color: '#2b2b2b',
      width: 282,
      height: 40,
      margin: 0,
      position: 'relative',
      fontSize: 14,
      lineHeight: '20px',
    },

    placementBusinessNameWithAdsLabel: {
      padding: '4px 0 !important',
      '& .ads-label': {
        ...defaultAdsLabelStyles,
        borderRadius: '2px !important',
        opacity: '1 !important',
      },
      '& .business-name': {
        padding: '0 !important',
        color: '#333 !important',
      },
    },
  };
};

export const getMmaInMsanV2MSNRestoday124x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '306px !important',
      height: 100,
      padding: 3,
      flexDirection: 'row !important',
    },

    placementImageContainer: {
      float: 'left',
      width: 108,
      height: 84,
      margin: '8px 4px 0 8px',
    },

    placementTextContainer: {
      padding: 2,
      color: '#333',
      fontSize: 10,
      lineHeight: '16px',
    },

    placementShortHeadline: {
      color: '#2b2b2b',
      height: 55,
      overflow: 'hidden',
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '22px',
      padding: '5px 0',
    },

    placementBusinessNameWithAdsLabel: {
      width: 177,
      padding: '8px 0 1px 0 !important',
      '& .ads-label': {
        ...defaultAdsLabelStyles,
        margin: '0 !important',
        opacity: '1 !important',
      },
      '& .business-name': {
        padding: '0 0 0 4px !important',
        margin: '9px 0 0 0 !important',
      },
      '& .ads-icon': {
        float: 'right',
        widht: 16,
        height: 16,
      },
    },
  };
};

export const getMmaInMsanV2MSANRectangle120x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);
  return {
    placementCard: {
      ...baseStyles.placementCard,
      '&:hover $placementGradient': {
        height: '480px !important',
        top: -200,
      },
      '&:hover $placementShortHeadline': {
        textDecoration: 'underline',
      },
      width: '300px !important',
      height: 250,
    },

    placementGradient: {
      display: 'block',
      width: '100%',
      height: '280px !important',
      top: 0,
      backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
    },

    placementTextContainer: {
      position: 'absolute',
      left: 20,
      bottom: 25,
      fontSize: 10,
      lineHeight: '16px',
    },

    placementShortHeadline: {
      color: 'white',
      width: 268,
      fontSize: 20,
      fontFamily: 'Segoe UI Semibold',
      fontWeight: '200',
      lineHeight: '26px',
      marginBottom: 20,
      paddingBottom: 5,
    },

    placementBusinessNameWithAdsLabel: {
      position: 'absolute',
      bottom: -10,
      fontWeight: '600',
      lineHeight: 1.364,
      fontSize: 12,
      padding: '2px 0 4px 0 !important',
      '& .ads-label': {
        ...defaultAdsLabelStyles,
        color: 'hsla(0,0%,100%,.7) !important',
        fontSize: '12px !important',
        fontWeight: '600 !important',
        border: '.5px solid hsla(0,0%,100%,.7) !important',
        opacity: '1 !important',
      },
      '& .business-name': {
        padding: '0 !important',
        margin: '0 !important',
        color: 'hsla(0,0%,100%,.7) !important',
        fontWeight: '600 !important',
      },
    },
  };
};

export const getMmaInMsanV2MicrosoftEdgeMobile1x1Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {

    placementCard: {
      ...baseStyles.placementCard,
      color: '#ddd',
      width: '240px !important',
      height: 90,
      padding: 3,
      background: '#fff',
      flexDirection: 'row !important',
    },

    placementImageContainer: {
      float: 'right',
      width: 80,
      height: 75,
      margin: 8,
    },

    placementTextContainer: {
      marginLeft: 8,
      fontSize: 10,
      lineHeight: '16px',
    },

    placementShortHeadline: {
      color: 'black',
      height: 45,
      margin: '8px 0',
      overflow: 'hidden',
      fontSize: 14,
      fontFamily: 'Segoe UI',
      fontWeight: 600,
      lineHeight: '22px',
      paddingBottom: 5,
    },

    placementBusinessNameWithAdsLabel: {
      lineHeight: '20px !important',
      fontFamily: 'Segoe UI',
      padding: '4px 0 !important',
      position: 'relative',
      top: 0.5,
      '& .ads-label': {
        ...defaultAdsLabelStyles,
        margin: '0 !important',
        color: '#2b2b2b !important',
        border: '.5px solid rgba(43, 43, 43, .3) !important',
        opacity: '1 !important',
        fontSize: '11px !important',
      },
      '& .business-name': {
        position: 'relative !important',
        padding: '12px !important',
        margin: '0 !important',
        color: '#2b2b2b !important',
        fontSize: '11px !important',
      },
    },
  };
};
